import React from 'react';
import { useHistory } from "react-router-dom";
import IconMobileApp from '../../../images/project-mobile.svg';
import IconSeriesSymfony from '../../../images/project-series.svg';
import IconDiscothequeGestion from '../../../images/project-discotheque.svg';
import {
    ProjectsContainer,
    ProjectsWrapper,
    ProjectsCard,
    ProjectsIcon,
    ProjectsH1,
    ProjectsH2,
    ProjectsP
} from './ProjectsElements';

const Projects = () => {
    const history = useHistory();

    const handleClick = (url) => {
        history.push(url);
    }


    return (
        <ProjectsContainer id="projects" className="darkBackground">
            <ProjectsH1 className="lightColor">Projets récents</ProjectsH1>
            <ProjectsWrapper>
                <ProjectsCard className="lightBackground" onClick={() => handleClick("/lotus")}>
                    <ProjectsIcon src={IconMobileApp} />
                    <ProjectsH2> Application mobile</ProjectsH2>
                    <ProjectsP>Application d'apprentissage de l'égyptien en kotlin </ProjectsP>
                </ProjectsCard>
                <ProjectsCard className="lightBackground" onClick={() => handleClick("/gcss")}>
                    <ProjectsIcon src={IconSeriesSymfony} />
                    <ProjectsH2>Site web Symfony</ProjectsH2>
                    <ProjectsP>Site de catalogue, de suivie de séries</ProjectsP>
                </ProjectsCard>
                <ProjectsCard className="lightBackground" onClick={() => handleClick("/disco")}>
                    <ProjectsIcon src={IconDiscothequeGestion} />
                    <ProjectsH2>Application C# de gestion</ProjectsH2>
                    <ProjectsP>Gestion d'emprunt d'une discotheque</ProjectsP>
                </ProjectsCard>
            </ProjectsWrapper>
        </ProjectsContainer>
    )
}

export default Projects
